import HttpService from './HttpService';
const API_ENDPOINT = '/campaign';

const CampaignService = {
  async getCampaigns() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getCampaignsPaginated(pageConfig) {
    const pageConfigParams =  new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(`${API_ENDPOINT}-paginated?${pageConfigParams}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async addCampaign(data) {
    try {
      const response = await HttpService.post(API_ENDPOINT, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async editCampaign(id) {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}/${id}/edit`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateCampaign(campaignId, data) {
  try {
      const response = await HttpService.put(`${API_ENDPOINT}/${campaignId}`, data);
      return response.data;
  } catch (error) {
      throw error;
  }
  },
  async deleteCampaign(campaignId) {
  try {
      const response = await HttpService.delete(`${API_ENDPOINT}/${campaignId}`);
      return response.data;
  } catch (error) {
      throw error;
  }
 }
};

export default CampaignService;